module.exports = __webpack_public_path__ + "img/advantagesImg4.74292bc7.png";